import PrintIcon from "~icons/local/print";

export default function Print({ fileUrl }: { fileUrl: string }) {
  return (
    <PrintIcon onClick={() => print(fileUrl)} className="cursor-pointer" />
  );
}

async function print(fileUrl: string) {
  const printFrame = document.createElement("iframe");
  printFrame.style.display = "none";
  document.body.appendChild(printFrame);

  const file = await fetch(fileUrl);
  const data = await file.blob();
  const localPdf = window.URL.createObjectURL(
    new window.Blob([data], { type: "application/pdf" }),
  );
  printFrame.setAttribute("src", localPdf);
  printFrame.onload = () => {
    printFrame.focus();
    printFrame.contentWindow?.print();
  };

  const event = "focus";
  window.addEventListener(event, cleanup);

  function cleanup() {
    window.removeEventListener(event, cleanup);
    printFrame.remove();
  }
}
